


















































import {Component, Vue} from 'vue-property-decorator';
import {httpClient} from '@/api/baseApi';
import Loading from '@c/controls/Loading.vue';

/*
    Элемент журнала входов. Имена полей приходят из массива fields ответа /api/logs/login:
    ожидаемо: [timestamp, user_id, user_name(позже), ip_address, browser, is_success, duration].
    user_name добавляется сервером позже; пока выводим id, как только появится имя —
    показываем "user_name (user_id)".
*/
interface LoginItem {
  timestamp: number;
  user_id: number;
  user_name?: string;
  ip_address?: string;
  browser?: string;
  is_success?: boolean;
  duration?: number;
  user: string;
}

@Component({components: {Loading}})
export default class LogsLogin extends Vue {
  items: LoginItem[] = [];
  loading = true;
  error = false;
  page = 1;
  itemsPerPage = 10;

  filterStartDate = '';
  filterEndDate = '';
  filterSuccess: boolean | '' = '';
  filterIP = '';

  successOptions = [
    {text: 'Все', value: ''},
    {text: 'Успешные', value: true},
    {text: 'Проблемные', value: false},
  ];

  //Состав колонок приходит от сервера (пока только user_id, позже добавят user_name и др.),
  //поэтому заголовки собираются динамически из fields. user_id/user_name сворачиваются
  //в одну колонку "Пользователь" вида "user_name (user_id)".
  headers: any[] = [];

  created() {
    this.fetch();
  }

  userDisplay(id: any, name?: string): string {
    if (name !== undefined && name !== null && name !== '') {
      return `${name} (${id})`;
    }
    return id !== undefined && id !== null && id !== '' ? String(id) : '';
  }

  headerTitle(name: string): string {
    const map: {[k: string]: string} = {
      timestamp: 'Время',
      user: 'Пользователь',
      ip_address: 'IP-адрес',
      browser: 'Браузер',
      is_success: 'Статус',
      duration: 'Длительность',
      uuid: 'UUID',
    };
    return map[name] || name;
  }

  buildHeaders(names: string[]) {
    //user_id/user_name не показываем отдельными колонками — сворачиваем в "user".
    const cols = names.filter(n => n !== 'user_id' && n !== 'user_name');
    if (names.includes('user_id') || names.includes('user_name')) {
      const tsIdx = cols.indexOf('timestamp');
      if (tsIdx >= 0) cols.splice(tsIdx + 1, 0, 'user');
      else cols.unshift('user');
    }
    this.headers = cols.map(name => {
      const h: any = {text: this.headerTitle(name), value: name};
      if (name === 'user') h.width = '240px';
      if (name === 'timestamp') h.width = '190px';
      if (name === 'is_success') {
        h.width = '90px';
        h.sortable = false;
      }
      return h;
    });
  }

  buildParams() {
    //Клиентская пагинация: грузим весь набор (лимит 1000), листает v-data-table.
    //Сервер не возвращает total — серверная пагинация невозможна.
    const params: any = {limit: 1000};
    if (this.filterStartDate) {
      params.start_date = new Date(this.filterStartDate).getTime();
    }
    if (this.filterEndDate) {
      params.end_date = new Date(this.filterEndDate).getTime() + 24 * 60 * 60 * 1000 - 1;
    }
    if (this.filterSuccess === true || this.filterSuccess === false) {
      params.is_success = this.filterSuccess;
    }
    if (this.filterIP) {
      params.ip_address = this.filterIP;
    }
    return params;
  }

  async fetch() {
    this.loading = true;
    this.error = false;
    try {
      const {data} = await httpClient.get('/logs/login', {params: this.buildParams()});
      const [rows, fields] = data;
      const names = (fields || []).map((f: any) => f[0]);
      this.buildHeaders(names);
      this.items = (rows || []).map((row: any) => {
        const item: any = {user: ''};
        names.forEach((name: string, i: number) => {
          item[name] = row[i];
        });
        item.user = this.userDisplay(item.user_id, item.user_name);
        return item as LoginItem;
      });
      this.page = 1;
      this.loading = false;
    } catch (e) {
      this.loading = false;
      this.error = true;
    }
  }

  applyFilters() {
    this.page = 1;
    this.fetch();
  }

  resetFilters() {
    this.filterStartDate = '';
    this.filterEndDate = '';
    this.filterSuccess = '';
    this.filterIP = '';
    this.page = 1;
    this.fetch();
  }

  formatTs(ts: number | undefined | null): string {
    if (!ts) return '';
    const ms = ts < 1e12 ? ts * 1000 : ts;
    return new Date(ms).toLocaleString('ru-RU');
  }
}
